<div class="wrapper">
  <div class="container mx-auto md:px-4 w-full">
    <app-header></app-header>
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
